import { authTokenKey } from "../constants/constants";

export const getAuthHeader = () => {
  let authToken = localStorage.getItem(authTokenKey);
  let authHeader = {
    Authorization: 'Bearer ' + authToken,
  }
  return authHeader;
}
